// extracted by mini-css-extract-plugin
export default {"divContainer":"styles_divContainer__8ubz5","img":"styles_img__xctA6"};